import { Pipe, PipeTransform } from '@angular/core';
import { MonitoringAlarm } from '../models/monitoring-alarm';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'alarmTypeUniqueValues'
})
export class AlarmTypeUniqueValuesPipe implements PipeTransform {
  constructor (
    private translate: TranslateService
  ) {
    
  }
  transform(alarms: MonitoringAlarm[]): {label: string; value: number}[] {
    const severityTypes = alarms && [...new Set(alarms.map(alarm =>alarm.severity_label))] || [];

    return severityTypes.map(label => {
      const alarm = alarms.find(alarm => alarm.severity_label === label)
      return {
        label: this.translate.instant(label),
        value: alarm ? alarm.severity : -1
      }
    })

  }



}
